import { render, staticRenderFns } from "./snsJoinForm.vue?vue&type=template&id=a98eb2b8&scoped=true"
import script from "./snsJoinForm.vue?vue&type=script&lang=js"
export * from "./snsJoinForm.vue?vue&type=script&lang=js"
import style0 from "./snsJoinForm.vue?vue&type=style&index=0&id=a98eb2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98eb2b8",
  null
  
)

export default component.exports